
import {IonCard, IonCardContent, IonLabel, IonInput, IonList, IonItem, IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
IonRadioGroup, IonRadio, IonCheckbox,
IonLoading, IonButton } from '@ionic/vue';

import ExploreContainer from '@/components/ExploreContainer.vue';
import bookservice from '@/bookservice';
import { ref } from '@vue/reactivity';
import Book from '@/model/Book';
import Contact from '@/model/Contact';
import { computed } from '@vue/runtime-core';
import router from '../router/index';
import Config from '@/assets/Config';


export default  {
  name: 'Tab2',
  components: {  IonLabel, IonInput, IonList, IonItem, IonHeader, IonToolbar, IonTitle, IonContent, IonPage, IonButton,
  IonCard, IonCardContent,
  IonRadioGroup,IonRadio,IonCheckbox,
  IonLoading  },


  setup(context: any, props: any){
        console.log(props)
        const {books} = bookservice();
        const booksSelected = computed(()=>books.value.filter(b=>b.selected));
        const booksCount = computed(()=>books.value.filter(b=>b.selected).length);
        //const booksPrice = computed(()=>books.value.reduce((total, b)=>total+(b.selected?1:0)*b.price, 0));
        const booksPrice = computed(()=>books.value.reduce((total, b)=>{
            return total+(b.selected?1:0)*b.price;
        },0));
        //const contact = ref<Contact>(Contact.contact);
        const contact = Contact.contact;
        const mothername = ref<string>('xx')

        const bancoLibros = computed(()=>{
            const found: any  = books.value.filter(b=>b.selected);
            return found.length && (found[0].course.id == '1Pri' || found[0].course.id == '2Pri');
        })

        const canSend = computed(()=>{
            console.log(contact.value)
            const c=contact.value;
            if (c.name.length<5) return false;
            if (!c.aceptado) return false;
            if (
                !((c.fatherphone && c.fatherdni) || (c.motherphone && c.motherdni))

            ) return false;
            if (!(c.imagen=='SI' || c.imagen=='NO')) return false;
            return true;

        })

        const isOpenRef = ref(false);
        const setOpen = (state: boolean) => {
            try{

            isOpenRef.value = state;
            }catch(e){
                console.error(e)
            }
        }

        const condiciones = ()=>{
            router.push('/condiciones');
        }

        const send = ()=>{
            setOpen(true);
            const controller = new AbortController();
            const signal = controller.signal;
            console.log(booksSelected)
            const booking: any = {
                ...Contact.contact.value,
                books: books.value.filter(b=>b.selected).map(b=>{
                    return {
                        ...b,
                        course: b.course.id
                    }

                }),
                date: JSON.stringify(new Date)
            };
            setTimeout(()=>{
                controller.abort();
                setOpen(false)
            }, 40000)
            fetch(Config.URL+'/save2',{
                method: 'POST',
                signal,
                headers: {
                    "Content-Type" : "application/json"
                },
                mode: 'cors',
                body: JSON.stringify(booking)

            }).then(r=>r.json())
            .then(d=>{
                console.log("guardado?", d)
                if (d && d._id){
                    contact.value._id=d._id;
                    contact.value.code=d.code;
                router.replace('/ok');
                }else{
                    router.push('/error')
                }
            })
        }

        const libros = ()=> router.replace('/tabs/tab1');

        const fecha=computed(()=>(contact.value.date.replaceAll(/[TZ]/g,' ')))

        return { books, booksSelected, booksCount, booksPrice, contact,  mothername, send, canSend, isOpenRef, condiciones, setOpen, fecha, libros, bancoLibros }
  }
}
